export const pluralize = (word: string, count: number): string =>
    count <= 1 ? word : `${word}s`

export const minifyObject = <T>(obj: T): string => btoa(JSON.stringify(obj))
